import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WorldBuilderModalComponent } from './modal/world-builder-modal.component';
import { WelcomeStepComponent } from './components/steps/welcome-step/welcome-step.component';
import { OverviewStepComponent } from './components/steps/overview-step/overview-step.component';
import { ResourceConfigStepComponent } from './components/steps/resource-config-step/resource-config-step.component';
import { AiModeStepComponent } from './components/steps/ai-mode-step/ai-mode-step.component';
import { ManualConfirmStepComponent } from './components/steps/ai-mode-step/manual-confirm-modal/manual-confirm-modal.component';
import { WorldIdentityStepComponent } from './components/steps/world-identity-step/world-identity-step.component';
import { AiModeConfirmStepComponent } from './components/steps/ai-mode-step/ai-mode-confirm-step/ai-mode-confirm-step.component';
import { GuidedConfirmStep2Component } from './components/steps/ai-mode-step/guided-confirm-modal/guided-confirm-modal.component';
import { GlobalContextStepComponent } from './components/steps/global-context-step/global-context-step.component';
import { GlobalContextStep2Component } from './components/steps/global-context-step-2/global-context-step-2.component';
import { GlobalContextStep3Component } from './components/steps/global-context-step-3/global-context-step-3.component';
import { GlobalContextStep4Component } from './components/steps/global-context-step-4/global-context-step-4.component';
import { CulturesStepComponent } from './components/steps/cultures-step/cultures-step.component';
import { ReligionsStepComponent } from './components/steps/religions-step/religions-step.component';
import { StatesStepComponent } from './components/steps/states-step/states-step.component';
import { ProvincesStepComponent } from './components/steps/provinces-step/provinces-step.component';
import { ReviewCreateStepComponent } from './components/steps/review-create-step/review-create-step.component';
import { WorldBuilderAbortConfirmModalComponent } from './modal/world-builder-abort-confirm-modal/world-builder-abort-confirm-modal.component';
import { UploadMapStepComponent } from './components/steps/upload-map-step/upload-map-step.component';

@NgModule({
  declarations: [
    WorldBuilderModalComponent,
    UploadMapStepComponent,
    WelcomeStepComponent,
    OverviewStepComponent,
    ResourceConfigStepComponent,
    AiModeStepComponent,
    ManualConfirmStepComponent,
    WorldIdentityStepComponent,
    AiModeConfirmStepComponent,
    GuidedConfirmStep2Component,
    GlobalContextStepComponent,
    GlobalContextStep2Component,
    GlobalContextStep3Component,
    GlobalContextStep4Component,
    CulturesStepComponent,
    ReligionsStepComponent,
    StatesStepComponent,
    ProvincesStepComponent,
    ReviewCreateStepComponent,
    WorldBuilderAbortConfirmModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  exports: [
    WorldBuilderModalComponent
  ]
})
export class WorldBuilderModule { }


